module.exports = __webpack_public_path__ + "static/img/jd_course_logo.a79c440b.png";